var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7395 3.05565L0.47545 20.8322C0.290045 21.1533 0.192417 21.5174 0.192383 21.8882C0.192349 22.2589 0.289909 22.6231 0.475254 22.9441C0.6606 23.2652 0.9272 23.5318 1.24825 23.7171C1.5693 23.9025 1.93349 24 2.30421 24H22.8307C23.2014 24 23.5656 23.9025 23.8866 23.7171C24.2077 23.5318 24.4743 23.2652 24.6596 22.9441C24.845 22.6231 24.9426 22.2589 24.9425 21.8882C24.9425 21.5174 24.8449 21.1533 24.6595 20.8322L14.3965 3.05565C14.2112 2.73469 13.9446 2.46816 13.6237 2.28286C13.3027 2.09755 12.9386 2 12.568 2C12.1974 2 11.8333 2.09755 11.5123 2.28286C11.1914 2.46816 10.9248 2.73469 10.7395 3.05565Z",
    fill: "#B00000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7015 8.53809H12.4338C11.7746 8.53809 11.2402 9.07246 11.2402 9.73164V15.4366C11.2402 16.0958 11.7746 16.6302 12.4338 16.6302H12.7015C13.3607 16.6302 13.8951 16.0958 13.8951 15.4366V9.73164C13.8951 9.07246 13.3607 8.53809 12.7015 8.53809Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5677 21.1553C13.3008 21.1553 13.8951 20.561 13.8951 19.8279C13.8951 19.0948 13.3008 18.5005 12.5677 18.5005C11.8345 18.5005 11.2402 19.0948 11.2402 19.8279C11.2402 20.561 11.8345 21.1553 12.5677 21.1553Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.f0ee11f3a141a30474ba1c8c6d261319.svg";
export { ForwardRef as ReactComponent };